wbApp.controller('DomainsSpecializationsCtrl', ['$scope', '$modal', '$translate', 'domainsSpecializationsSvc',
function ($scope, $modal, $translate, domainsSpecializationsSvc) {

    function setSelectedDomain(domain, refresh) {
        $scope.selectedDomain = domain;
        $scope.$broadcast('selectedDomainChanged', { domain: domain, refresh: !!refresh });
    }

    $scope.selectedDomain = null;
    var isActive = false;
    var loaded = false;
    $scope.domainsSpecializations = [];

    $scope.$on('selectedDomainChanged', function (e, domainInd) {
        if (domainInd.domain) {
            if (isActive) {
                if ($scope.selectedDomain !== domainInd.domain || domainInd.refresh) {
                    $scope.domainsSpecializations = domainsSpecializationsSvc.getAll(domainInd.domain.id);
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.domainsSpecializations = [];
        }
        $scope.selectedDomain = domainInd.domain;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                if (!loaded && $scope.selectedDomain) {
                    $scope.domainsSpecializations = domainsSpecializationsSvc.getAll($scope.selectedDomain.id);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.domainsSpecializationsGridSettings = {
        name: 'domainsSpecializations',
        columns: [
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '270px', sortOrder: 'asc' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string' },
            { dataField: 'reservationTeacherHourSingleRate', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '80px' },
            { dataField: 'reservationTeacherHourGroupOneRate', caption: $translate.instant('TXT_LBL_GRP_ONE_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '80px' },
            { dataField: 'reservationTeacherHourGroupTwoRate', caption: $translate.instant('TXT_LBL_GRP_TWO_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '80px' },
            { dataField: 'disabledForClients', caption: $translate.instant('TXT_DISABLED_FOR_CLIENTS'), dataType: 'boolean', width: '60px' },
        ]
    }

    $scope.onRowSelected = function (data) {
        setSelectedDomain(data);
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.domainId = $scope.selectedDomain.id;
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onSave = function () {
                $scope.domainsSpecializations = domainsSpecializationsSvc.getAll($scope.selectedDomain.id);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.domainId = $scope.selectedDomain.id;
            detailDialogPromise.$scope.model = domainsSpecializationsSvc.createNew();
            detailDialogPromise.$scope.onSave = function () {
                $scope.domainsSpecializations = domainsSpecializationsSvc.getAll($scope.selectedDomain.id);
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        domainsSpecializationsSvc.remove(
            $scope.selectedDomain.id,
            data,
            function () {
                $scope.domainsSpecializations = domainsSpecializationsSvc.getAll($scope.selectedDomain.id);
            });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'reservations/domains/domains-specializations-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
